"use client";

import { memo, Suspense } from "react";
import { useSearchParams } from "next/navigation";
import ConfirmationLayoutV2 from "./components/PostPurchaseAccountCard/ConfirmationLayoutV2";

// PROD-2026-05-18-011 — Layout V2 is now the default post-purchase
// experience for every successful order. The old r1 confirmed-order
// card and the r2 inline preview switcher have been removed. The
// account-creation card inside Layout V2 hits the real backend
// (createUser / login / getUserByEmail) and Layout V2 still calls
// useGTMPurchaseEvent + cleanUp the same way the legacy card did,
// so analytics + cart-cleanup parity is preserved.

const OrderConfirmationBody = () => {
  const params = useSearchParams();
  const orderId = params.get("orderId");
  return <ConfirmationLayoutV2 orderId={orderId} />;
};

export const OrderConfirmationPage = () => {
  return (
    <main className="w-full full-height bg-background-secondary flex flex-col justify-center">
      <section className="section flex flex-auto pt-[var(--main-header-height,56px)] lg:pt-[var(--main-header-height,54px)]">
        <div className="container mx-auto py-6 md:py-12">
          <Suspense>
            <OrderConfirmationBody />
          </Suspense>
        </div>
      </section>
    </main>
  );
};

export default memo(OrderConfirmationPage);
